/**
 * Окно «Новый персонаж» (владелец 10.10: «универсальный инструмент создания персонажа из любого отдела»): вызов из
 * любого места сайта — промис с созданным персонажем или null (окно закрыли). Хост — CharacterCreatorHost в App.
 *
 * Отдельный модуль, а не экспорт из хоста: файл с компонентом должен экспортировать только компоненты (react-refresh).
 */
import type { Asset } from '../api/assets'

export interface CharacterCreatorRequest {
	/** С чего начать: два выбора («Своё фото» / «Создать нового»), сразу «Своё фото» или сразу сборка. */
	start?: 'choose' | 'own' | 'new'
	/** Картинка «как есть» (слот генератора, кадр «Сцены»): окно «Своё фото» с ней. Только своя (проверит сервер). */
	seedUrl?: string
	/** Описание, с которого начать сборку (поле страницы «Персонажи»). */
	prompt?: string
}

type Opener = (req: CharacterCreatorRequest, resolve: (asset: Asset | null) => void) => void

let opener: Opener | null = null

/** Хост окна регистрирует себя при монтировании и снимает при размонтировании. */
export function registerCharacterCreatorOpener(fn: Opener | null): void {
	opener = fn
}

/** Открыть окно. Хоста нет (страница без App) — null, как закрытое окно. Повторный вызов при открытом окне
 *  заменяет прежний запрос: прежний получает null. */
export function openCharacterCreator(req: CharacterCreatorRequest = {}): Promise<Asset | null> {
	const open = opener
	if (!open) return Promise.resolve(null)
	return new Promise<Asset | null>((resolve) => open(req, resolve))
}
